import PropTypes from 'prop-types';
import { FormGroup, Label, TextField } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

import styles from './EinField.module.scss';

const EinField = ({ value, onChange, disabled }) => {
  const handleValueChange = event => onChange(event);

  return (
    <div className={styles.einField}>
      <FormGroup>
        <Label size="sm" for={credentialForm.einId}>
          {credentialForm.einLabel}
        </Label>
        <TextField
          id={credentialForm.einId}
          size="sm"
          value={value}
          onChange={handleValueChange}
          disabled={disabled}
        />
      </FormGroup>
    </div>
  );
};

EinField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

EinField.defaultProps = {
  value: '',
  onChange: noop,
  disabled: false,
};

export default EinField;
